import React, { useState } from "react";
import S3Uploader from "@/components/S3Uploader";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Paperclip } from "lucide-react";

export function CostReceiptsButton({ cost, canManage, onClosed }) {
  const [open, setOpen] = useState(false);
  const n = cost.receipt_count || 0;
  return (
    <>
      <button onClick={() => setOpen(true)} title={n ? `${n} receipt${n > 1 ? "s" : ""}` : "Attach receipt"} data-testid={`cost-receipts-${cost.id}`}
        className={`inline-flex items-center gap-1 rounded p-1 text-xs ${n ? "text-indigo-600 hover:bg-indigo-50" : "text-slate-400 hover:bg-slate-50 hover:text-slate-600"}`}>
        <Paperclip className="w-3.5 h-3.5" />{n > 0 && <span className="font-semibold" data-testid={`cost-receipt-count-${cost.id}`}>{n}</span>}
      </button>
      <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) onClosed?.(); }}>
        <DialogContent data-testid="cost-receipts-dialog">
          <DialogHeader><DialogTitle>Receipts · {cost.title}</DialogTitle></DialogHeader>
          <div className="mt-3">
            <S3Uploader recordType="costs" recordId={cost.id} category="Receipt" canManage={canManage} accept="image/*,application/pdf" serverSide />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

export function CostBreakdownRows({ costs, gbp }) {
  const groups = {};
  costs.forEach((c) => { const k = c.account_type || "Other"; (groups[k] = groups[k] || []).push(c); });
  return (
    <div className="px-5 pb-1" data-testid="finance-cost-items">
      {Object.entries(groups).map(([k, rows]) => (
        <div key={k} className="py-1">
          <div className="flex justify-between text-[11px] font-semibold uppercase tracking-wide text-slate-400">
            <span>{k}</span><span>{gbp(rows.reduce((a, c) => a + (c.total || 0), 0))}</span>
          </div>
          {rows.map((c) => (
            <div key={c.id} className="flex justify-between pl-3 text-xs text-slate-500" data-testid={`finance-cost-item-${c.id}`}>
              <span className="truncate">{c.title}{c.source === "expense" ? " (expense)" : ""}</span><span className="tabular-nums">{gbp(c.total)}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
